<template>
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    max-width="1000px"
  >
    <v-card>
      <v-card-title>
        <span>Chi tiết bảng giá</span>
        <v-divider
          class="mx-4"
          inset
          vertical
        ></v-divider>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Nhập tên sản phẩm"
          class="shrink"
          single-line
          clearable
        />
        <v-spacer/>
        <v-menu
          bottom
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              @click="close()"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-menu>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :page="page"
          :pageCount="numberOfPages"
          :options.sync="options"
          :server-items-length="totalItems"
          :headers="headers"
          :items="items"
          :search="search"
          :loading="loading"
          loading-text="Đang tải dữ liệu... Vui lòng chờ"
          :items-per-page="perPage"
          :footer-props="{
            showFirstLastPage: true
          }"
        >
          <template v-slot:[`item.id`]="{ index }">
            {{ (perPage * (page-1)) +  (index+1) }}
          </template>
          <template v-slot:item.l_price="{ item }">
            {{ item.l_price | currency('đ') }}
          </template>
          <template v-slot:item.h_price="{ item }">
            {{ item.h_price | currency('đ') }}
          </template>
          <template v-slot:item.actions="{ item }">
            <div style="white-space: nowrap;">
              <v-btn
                icon
                color="primary"
                @click="editItem(item)"
              >
                <v-icon>
                  mdi-pencil
                </v-icon>
              </v-btn>
              <v-btn
                icon
                color="pink"
                @click="deleteItem(item)"
              >
                <v-icon>
                  mdi-delete
                </v-icon>
              </v-btn>
            </div>
          </template>
          <template v-slot:no-data>
            <v-btn
              color="primary"
              @click="initialize"
            >
              Tải lại
            </v-btn>
          </template>
        </v-data-table>
        <Form 
          :showDialog="editDialog" 
          :item="item" 
          @confirmed="onConfirmed" 
          @cancelled="onCancelled"
        />
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="headline">Bạn có chắc bạn muốn xóa mục này?</v-card-title>
            <v-card-actions>
              <v-spacer/>
              <v-btn color="primary darken-1" text @click="closeDelete">Hủy bỏ</v-btn>
              <v-btn color="pink darken-1" text @click="deleteItemConfirm">Đồng ý</v-btn>
              <v-spacer/>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          color="pink darken-1"
          text
          @click="close"
        >
          Đóng lại
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  function formatAsCurrency (value, dec) {
    dec = dec || 0;
    if (value === null) {
      return '';
    }
    return '' + parseFloat(value).toFixed(dec).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
  }
  import Form from '@/views/admin/markets/Form';
  import { mapActions } from 'vuex';
  export default {
    components: { 
      Form
    },
    props: {
      showDialog: {
        type: Boolean,
        default: false
      },
      priceDetail: {
        type: Object
      }
    },
    data () {
      return {
        loading: false,
        dialog: false,
        editDialog: false,
        dialogDelete: false,
        search: '',
        sortDesc: true,
        sortBy: "ngay_cap_nhat",
        headers: [
          { text: 'STT', value: 'id' },
          { text: 'Mặt hàng', value: 'market_product.name' },
          { text: 'Ngày cập nhật', value: 'ngay_cap_nhat' },
          { text: 'ĐVT', value: 'market_product.don_vi_tinh' },
          { text: 'Giá thấp(đ)', value: 'l_price' },
          { text: 'Giá cao(đ)', value: 'h_price' },
          { 
            align: 'right', 
            text: 'Thao tác', 
            value: 'actions', 
            sortable: false 
          },
        ],
        page: 1,
        totalItems: 0,
        numberOfPages: 0,
        perPage: 10,
        items: [],
        editedIndex: -1,
        item: {},
        options: {},
        timeout: null,
        awaitingSearch: false,
      }
    },
    mounted() {
      this.dialog = this.showDialog;
    },
    watch: {
      showDialog() {
        this.dialog = false;
        if (this.showDialog) {
          this.options = {
            page: 1
          };
          this.dialog = true;
        }
      },
      options: {
        handler() {
          this.initialize();
        }
      },
      search(){
        if (this.timeout) clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.initialize();
        }, 1000);
      }
    },
    methods: {
      ...mapActions([
        'openSnackbar'
      ]),
      initialize () {
        const app = this;
        const { page, itemsPerPage } = app.options;
        let pageNumber = page;
        let request = {
          params: {
            size: itemsPerPage ? itemsPerPage : 10,
            page: pageNumber ? pageNumber : 1,
            date: app.priceDetail.ngay_cap_nhat,
            keyword: app.search
          }
        };
        app.loading = true;
        axios.get("api/v1/market-prices", request)
          .then(response => {
            app.items = response.data.data;
            app.totalItems = response.data.total;
            app.numberOfPages = response.data.to;
            app.page = response.data.current_page;
            app.perPage = response.data.per_page;
            app.loading = false;
          })
          .catch(function (error) {
            app.openSnackbar({ type: 'error' });
          });
      },
      close() {
        this.dialog = false;
        this.$emit('cancelled');
      },
      showEditDialog(item=null){
        this.editDialog = item||{};
        this.editDialog = true;
      },
      onConfirmed(item) {
        this.editDialog = false;
        this.initialize();
      },
      onCancelled () {
        this.editDialog = false;
      },
      editItem (item) {
        this.editedIndex = this.items.indexOf(item);
        this.item = Object.assign({}, item);
        this.editDialog = true;
      },
      deleteItem (item) {
        this.editedIndex = this.items.indexOf(item);
        this.item = Object.assign({}, item);
        this.dialogDelete = true;
      },
      deleteItemConfirm () {
        const app = this;
        axios.delete(`api/v1/market-prices/${app.item.id}`)
          .then(function (resp) {
            app.items = app.items.filter(val => val.id !== app.item.id);
            app.closeDelete();
            app.openSnackbar({ type: 'success' });
          }).catch(function (error) {
            app.openSnackbar({ type: 'error' });
          });
      },
      closeDelete () {
        this.dialogDelete = false;
        this.$nextTick(() => {
          this.item = Object.assign({}, this.item);
          this.editedIndex = -1;
        })
      }
    }
  }
</script>